import React from 'react'
import { Block } from '@comp/crRender'

const RequestDetailsSkeleton = ({ isRender }) => {
    return (
        <Block isRender={isRender} className="request-details-skeleton">
            <div className="skeleton-header-container">
                <div className="skeleton-title"></div>
                <div className="skeleton-button"></div>
            </div>
            
            <div className="skeleton-grid">
                <div className="skeleton-card">
                    <div className="skeleton-card-title"></div>
                    <div className="skeleton-info-row">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-value"></div>
                    </div>
                    <div className="skeleton-info-row">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-value"></div>
                    </div>
                    <div className="skeleton-info-row">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-value"></div>
                    </div>
                    <div className="skeleton-info-row">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-value skeleton-value-long"></div>
                    </div>
                </div>
                
                <div className="skeleton-card">
                    <div className="skeleton-card-title"></div>
                    <div className="skeleton-table">
                        <div className="skeleton-table-header">
                            <div className="skeleton-table-header-cell"></div>
                            <div className="skeleton-table-header-cell"></div>
                            <div className="skeleton-table-header-cell"></div>
                        </div>
                        <div className="skeleton-table-row">
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                        </div>
                        <div className="skeleton-table-row">
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                        </div>
                        <div className="skeleton-table-row">
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                            <div className="skeleton-table-cell"></div>
                        </div>
                    </div>
                </div>
            </div>
        </Block>
    )
}

export default RequestDetailsSkeleton

